import { TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { WidgetProps } from '@rjsf/utils';
import { Moment } from 'moment';
import 'moment/locale/de';
import * as React from 'react';

function CustomDate(props: WidgetProps) {
  const [value, setValue] = React.useState<Moment | null>(null);
  const hasSchemaError = Array.isArray(props.rawErrors) && props.rawErrors.length > 0;

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="de">
      <DatePicker
        label={props.label}
        value={value}
        onChange={(newValue: Moment | null) => {
          setValue(newValue);
          if (newValue) {
            props.onChange(newValue.format("DD.MM.YYYY"));
          }
        }
        }
        renderInput={(params) => <TextField {...params} fullWidth error={Boolean(params.error) || hasSchemaError} />}
      />
    </LocalizationProvider>
  );
}

export default CustomDate;